// Dados estruturados dos módulos do sistema Cwork Gestão / Veritux ERP

export const modulos = {
  comercial: {
    id: 'comercial',
    titulo: 'Módulo Comercial',
    icone: '🛒',
    descricao: 'Controle completo do departamento comercial da sua empresa, integrando-se aos demais módulos.',
    resumo: 'Gestão completa de vendas, orçamentos, pedidos e faturamento com controle de comissões.',
    funcionalidades: [
      {
        nome: 'Orçamentos',
        descricao: 'Registre todos os orçamentos realizados. Transforme orçamentos aprovados em pedidos de venda para faturamento.'
      },
      {
        nome: 'Pedidos de Venda',
        descricao: 'Cadastre todos os pedidos de venda com controle de tipo de pedido, reserva de estoque e aguardando faturamento.'
      },
      {
        nome: 'Faturamento',
        descricao: 'Emissão de notas fiscais (NF-e) e cupons fiscais (NFC-e). Busca de pedidos para cópia automática. Faturamento em lote.'
      },
      {
        nome: 'Controle de Comissão',
        descricao: 'Sistema completo de cálculo e controle de comissões de vendedores com tabelas personalizadas.'
      },
      {
        nome: 'Cadastro Unificado',
        descricao: 'Cadastro de pessoas unificado que evita informações duplicadas.'
      },
      {
        nome: 'Tipo de Movimentação',
        descricao: 'Reúne todos os parâmetros para cálculo das notas fiscais, incluindo CFOP.'
      }
    ],
    cadastros: [
      'Cadastro de Condições de Pagamento',
      'Cadastro de Clientes',
      'Cadastro de Funcionários',
      'Cadastro de Vendedores',
      'Cadastro de Produtos',
      'Cadastro de Pessoas',
      'Cadastro de Parâmetros',
      'Cadastro de Grupo de Estoque',
      'Cadastro de Unidade',
      'Cadastro de Tabela de Preço',
      'Cadastro de NCM',
      'Cadastro de Subproduto',
      'Cadastro de Empresa',
      'Cadastro de Classificação'
    ],
    operacoes: [
      'Orçamentos com transformação em pedidos',
      'Pedidos de venda com reserva de estoque',
      'Faturamento individual ou em lote',
      'Busca de pedidos para faturamento',
      'Cálculo automático de comissões',
      'Fechamento de comissões por período'
    ],
    relatorios: [
      'Relatórios Comerciais',
      'Relatórios de Comissão',
      'Relatórios com opção de salvar filtros'
    ],
    detalhes: {
      orcamentos: 'Nesta opção o usuário poderá registrar todos os orçamentos realizados na sua empresa. Caso esse orçamento for aprovado pelo cliente o usuário poderá transformá-lo em um pedido de venda liberando o mesmo para o faturamento. Estes orçamentos ficam armazenados no sistema servido como informação para futuras análises.',
      pedidos: 'Nesta opção o usuário irá cadastrar todos os pedidos de venda que aconteceram na sua empresa. Uma das informações que o sistema exige que seja informada durante o cadastro do pedido é o Tipo de Pedido. Com essa informação o sistema poderá identificar se os produtos que compõe esse pedido reservam estoque ou até mesmo permitem que esses mesmos produtos fiquem com estoque negativo. Depois de um pedido de venda for lançado o usuário tem a opção de faturar esse pedido ou deixar aguardando faturamento.',
      faturamento: 'É nesta opção que o usuário do sistema irá controlar o faturamento da sua empresa. O Faturamento pode acontecer de duas formas, emite-se uma nota fiscal ou um cupom fiscal. Quando esse faturamento acontecer o usuário não precisará lançar novamente todo o pedido para emitir o faturamento, ele terá um recurso chamado "Busca Pedido" que irá fazer uma cópia do pedido para a nota fiscal. Com isso o usuário irá apenas conferir as informações e faturar o pedido. O mesmo acontece para os pedidos que irão ser faturados todos no final do mês, o sistema tem uma opção que o usuário seleciona quais pedidos devem entrar naquele faturamento, fazendo isso o sistema junta todos os produtos em uma única nota fiscal.',
      comissao: 'A configuração do percentual de comissão acontece da seguinte maneira: cria uma tabela de comissão; depois da tabela criada relaciona os produtos e seus percentuais de comissão a uma tabela de comissão; e por último informa no cadastro do vendedor qual tabela ele utiliza. Quando lança um orçamento, pedido e nota fiscal o sistema pede a informação do vendedor, mas é no faturamento que o sistema irá calcular a comissão do vendedor. Logo após o faturamento gerar o financeiro o sistema alimenta o conta corrente do vendedor com o valor da sua comissão referente aquele faturamento.'
    }
  },
  compras: {
    id: 'compras',
    titulo: 'Módulo de Compras',
    icone: '📦',
    descricao: 'Controle completo do departamento de compras da sua empresa, integrando-se aos demais módulos.',
    resumo: 'Gestão de cotações, pedidos de compra e notas de entrada com controle de fornecedores.',
    funcionalidades: [
      {
        nome: 'Cotação',
        descricao: 'Administre todas as solicitações de compras. Cada cotação permite até 6 fornecedores. Sistema mostra produtos mais baratos e fornecedor mais barato.'
      },
      {
        nome: 'Pedidos de Compra',
        descricao: 'Controle todos os pedidos de compras. Pedidos podem ser faturados parcialmente. Quantidades ficam armazenadas na coluna de Compras no estoque.'
      },
      {
        nome: 'Notas de Entrada',
        descricao: 'Lançamento de todas as notas de compras. Recurso "Busca Pedido" para conferência rápida. Alimenta automaticamente Financeiro e Estoque.'
      },
      {
        nome: 'Importação XML',
        descricao: 'Importe XML de fornecedores automaticamente.'
      }
    ],
    cadastros: [
      'Cadastro de Fornecedores',
      'Cadastro de Produtos',
      'Cadastro de Condições de Pagamento'
    ],
    operacoes: [
      'Cotações com até 6 fornecedores',
      'Análise de produtos mais baratos',
      'Geração automática de pedidos de compra',
      'Pedidos de compra com faturamento parcial',
      'Busca de pedidos para nota de entrada',
      'Importação de XML de fornecedores'
    ],
    relatorios: [
      'Relatórios de Compras',
      'Relatórios de Cotações',
      'Relatórios de Pedidos'
    ],
    detalhes: {
      cotacao: 'Nesta opção o usuário consegue administrar todas as solicitações de compras que acontecem na sua empresa. Cada cotação tem um limite de 6 fornecedores, ou seja, o usuário abre uma cotação de produtos com o número máximo de 6 fornecedores. Depois de lançado os preços dos produtos cotados o sistema mostra para o usuário quais são os produtos mais baratos, qual o fornecedor mais barato. Com essas informações o usuário irá decidir em qual fornecedor comprar os produtos mais baratos ou até mesmo escolher o fornecedor mais barato, podendo ainda escolher outro fornecedor que foi contato. Com a decisão do usuário em qual fornecedor comprar os produtos o sistema irá gerar automaticamente os pedidos de compra.',
      pedidos: 'Nesta opção o usuário estará controlando todos os pedidos de compras de sua empresa. Estes pedidos podem ser faturados parcialmente, pois nem sempre os fornecedores mandam todo o pedido ou com quantidades alteradas. Com esse recurso o usuário conseguirá conferir se seu fornecedor mandou realmente o que sua empresa pediu. Uma vez lançado o pedido de compra, as quantidades dos produtos pedidos ficam armazenadas na coluna de Compras no controle de estoque, pois ao consultar o estoque de um determinado produto o usuário fica sabendo se esse produto tem alguma compra programada.',
      compras: 'É nesta opção que o usuário irá lançar todas as notas de compras de sua empresa. Esta opção tem o mesmo recurso que o faturamento de pedidos no módulo comercial, o usuário não precisar lançar produto por produto, basta chamar o processo "Busca Pedido" e fazer a conferência dos produtos com suas quantidades, depois finaliza essa conferência para acertar a condição de pagamento ou até mesmo buscar mais um pedido de compra. Ao término do lançamento de uma compra o sistema alimenta o módulo de Financeiro (Contas a Pagar) e o estoque dos produtos. Caso essa compra tenha sido lançada através do pedido de compra o sistema também baixa esse pedido informando que suas quantidades foram entregues.'
    }
  },
  estoque: {
    id: 'estoque',
    titulo: 'Módulo de Estoque',
    icone: '📊',
    descricao: 'Controle completo do departamento de Estoque da sua empresa, integrando-se aos demais módulos.',
    resumo: 'Gestão completa de inventário, movimentações, estoque mínimo e análise Curva ABC.',
    funcionalidades: [
      {
        nome: 'Controle de Estoque',
        descricao: 'Visualize toda a movimentação de estoque da sua empresa. Saiba em que dia tal produto foi vendido e para quem foi vendido.'
      },
      {
        nome: 'Estoque Mínimo',
        descricao: 'Configure o estoque mínimo de cada produto. O sistema avisa quando o produto chega ao mínimo através de relatório e durante lançamentos.'
      },
      {
        nome: 'Curva ABC',
        descricao: 'Visualização do estoque classificando os produtos na classe ABC, permitindo análise de quais produtos merecem atenção especial.'
      },
      {
        nome: 'Requisições',
        descricao: 'Controle de requisições de entrada e saída de estoque.'
      },
      {
        nome: 'Balanço',
        descricao: 'Realize balanços de estoque para conferência física.'
      }
    ],
    cadastros: [
      'Cadastro de Produtos',
      'Cadastro de Grupo de Estoque',
      'Cadastro de Unidade',
      'Cadastro de Empresa'
    ],
    operacoes: [
      'Consulta por Empresa',
      'Consulta por Produto',
      'Requisição de Saída',
      'Requisição de Entrada',
      'Balanço de Estoque',
      'Consulta de posição de estoque'
    ],
    relatorios: [
      'Relatório de Estoque Mínimo',
      'Relatório de Necessidade de Compras',
      'Relatório Curva ABC',
      'Relatório de Movimentação de Estoque'
    ],
    detalhes: {
      estoque: 'É nesta opção que o usuário irá controlar/visualizar toda a movimentação de estoque da sua empresa, podendo saber em que dia tal produto foi vendido e para quem foi vendido.',
      estoqueMinimo: 'Neste módulo de estoque o sistema permite ainda configurar qual o estoque mínimo de cada produto. Configurado o estoque mínimo para cada produto o sistema irá avisar que este produto chegou ao mínimo através de relatório e quando este produto for laçado em um pedido/faturamento o sistema irá mostrar a mensagem que ficará abaixo do mínimo.',
      curvaABC: 'Está é uma opção de visualização do estoque, classificando os produtos na classe ABC, com isso o usuário poderá analisar quais os produtos que merecem uma atenção especial.'
    }
  },
  financeiro: {
    id: 'financeiro',
    titulo: 'Módulo Financeiro',
    icone: '💰',
    descricao: 'Controle completo do departamento Financeiro da sua empresa, integrando-se aos demais módulos.',
    resumo: 'Gestão de contas a pagar e receber, fluxo de caixa, boletos e contas bancárias.',
    funcionalidades: [
      {
        nome: 'Contas a Pagar',
        descricao: 'Controle todas as contas a pagar da empresa separada por Filiais. Documentos de fornecedores são lançados automaticamente pelo módulo de compras.'
      },
      {
        nome: 'Contas a Receber',
        descricao: 'Controle todas as contas a receber da empresa separada por Filiais. Boletos, Cheques, etc. são lançados pelo faturamento. Permite baixa múltipla.'
      },
      {
        nome: 'Emissão de Boletos',
        descricao: 'Emite boletos de todos os bancos com qualquer tipo de carteira. Impressão automática após nota fiscal ou manual por documento.'
      },
      {
        nome: 'Contas Bancárias',
        descricao: 'Controle sobre contas bancárias e/ou caixas da empresa. Permite transferências entre contas. Alimentado automaticamente por Contas a Pagar e Receber.'
      },
      {
        nome: 'Fluxo de Caixa',
        descricao: 'Gerenciamento de Fluxo de Caixa sintetizando todas as movimentações de contas a Pagar e Receber.'
      }
    ],
    cadastros: [
      'Cadastro de Acréscimos',
      'Cadastro Conta Bancária',
      'Cadastro Portador',
      'Cadastro Remessa',
      'Cadastro de Formas de Pagamentos'
    ],
    operacoes: [
      'Lançamento de contas a pagar',
      'Lançamento de contas a receber',
      'Baixa de documentos',
      'Emissão de boletos',
      'Transferência entre contas',
      'Consulta de Histórico do cliente',
      'Movimentação de Caixa'
    ],
    relatorios: [
      'Contas a Pagar por Vencimento/Previsão',
      'Contas a Pagar por Fornecedor',
      'Contas a Pagar por Data Lançamento',
      'Contas a Pagar em Abertas por Vencimento/Previsão',
      'Contas Pagas por Data de Pagamento',
      'Contas a Receber por Vencimento/Previsão',
      'Contas a Receber por Cliente',
      'Contas a Receber por Data Lançamento',
      'Contas a Receber em Abertas por Vencimento/Previsão',
      'Contas Recebidas por Data Recebimento',
      'Fluxo de Caixa Realizado',
      'Movimentação da Conta Bancária por Data',
      'Relatórios Financeiros (pagar e receber)'
    ],
    detalhes: {
      contasPagar: 'Nesta opção o usuário irá controlar todas as contas a pagar da empresa separada por Filiais. Com a integração do sistema praticamente o usuário não irá lançar os documentos referentes ao pagamento de fornecedores, pois esses já foram laçados através do módulo de compras, ficando apenas para lançar os pagamentos das despesas. Quando um documento a pagar for baixado o sistema perguntará ao usuário qual a conta bancaria que está sendo utilizada para esse pagamento. Com isso o sistema gera automaticamente uma saída na conta informada.',
      contasReceber: 'Nesta opção o usuário irá controlar todas as contas a receber da empresa separada por Filiais. Devido à integração do sistema todos os Boletos, Cheques, etc. serão lançados pelo faturamento encontrado no módulo Comercial. O sistema também irá permitir que lance documentos a receber diretamente deste módulo. Para um maior controle do usuário cada registro terá a informação da sua origem, Comercial ou Financeiro. O sistema permite que um documento seja baixado mais de uma vez desde que o saldo do documento não seja menor que 0 (zero). Quando um documento a receber é baixado o sistema irá perguntar qual o conta bancária, com isso após finalizar a baixa o sistema gera automaticamente uma entrada na conta bancária informada na hora da baixa.',
      boletos: 'O sistema emite boletos de todos os bancos com qualquer tipo de carteira. A emissão desses boletos acontece de forma rápida e clara: após a impressão da nota fiscal o sistema já imprime os boletos referentes a nota; selecionando um documento a receber, que esteja configurado como boleto, e depois clicar no botão chamado Imprimir Boleto.',
      contasBancarias: 'Nesta opção o usuário irá possuir um controle sobre suas contas bancarias e/ou caixas da empresa. O sistema permite que o usuário faça transferências entre suas contas. Praticamente esta opção será alimentada pela Contas a Receber e Contas a Pagar, ficando apenas para o usuário lançar as despesas bancárias e/ou o pagamento de algumas despesas que não passaram pelo financeiro (Contas a Pagar).'
    }
  },
  caixa: {
    id: 'caixa',
    titulo: 'Módulo de Caixa',
    icone: '💵',
    descricao: 'Controle completo de movimentações de caixa da sua empresa.',
    resumo: 'Gestão de lançamentos, fechamento de caixa, cheques e transferências bancárias.',
    funcionalidades: [
      {
        nome: 'Lançamento',
        descricao: 'Registre todas as movimentações de caixa da empresa.'
      },
      {
        nome: 'Fechamento de Caixa',
        descricao: 'Realize o fechamento de caixa com controle de valores e conferência.'
      },
      {
        nome: 'Cheque',
        descricao: 'Controle completo de histórico de cheques emitidos e recebidos.'
      },
      {
        nome: 'Transferência Bancária',
        descricao: 'Registre transferências entre contas bancárias da empresa.'
      }
    ],
    cadastros: [
      'Cadastro Conta Bancária',
      'Cadastro Portador',
      'Cadastro de Formas de Pagamentos'
    ],
    operacoes: [
      'Lançamento de movimentações',
      'Fechamento de Caixa',
      'Transferência entre contas',
      'Controle de Cheques'
    ],
    relatorios: [
      'Relatórios de Movimento de Caixa',
      'Relatório de Fechamento de Caixa',
      'Histórico de Cheques'
    ],
    detalhes: {
      lancamento: 'Sistema permite lançamento de todas as movimentações de caixa da empresa.',
      fechamento: 'Opções de fechamento de caixa com controle de valores e conferência.',
      cheque: 'Histórico completo de cheques emitidos e recebidos pela empresa.',
      transferencia: 'Registre transferências entre contas bancárias da empresa com controle completo.'
    }
  },
  notasFiscais: {
    id: 'notas-fiscais',
    titulo: 'Notas Fiscais Eletrônicas',
    icone: '📄',
    descricao: 'Emissão e controle de notas fiscais eletrônicas (NF-e, NFS-e e NFC-e).',
    resumo: 'Emissão de notas tipo NF-e, NFS-e e NFC-e com integração à Receita Federal.',
    funcionalidades: [
      {
        nome: 'NF-e (Nota Fiscal Eletrônica)',
        descricao: 'Emissão de notas fiscais eletrônicas para produtos com validação automática na SEFAZ.'
      },
      {
        nome: 'NFS-e (Nota Fiscal de Serviços Eletrônica)',
        descricao: 'Emissão de notas fiscais de serviços eletrônicas integrada com a prefeitura.'
      },
      {
        nome: 'NFC-e (Nota Fiscal de Consumidor Eletrônica)',
        descricao: 'Emissão de cupons fiscais eletrônicos para vendas ao consumidor final.'
      },
      {
        nome: 'Envio em Lote',
        descricao: 'Envio das notas do mês, todas de uma única vez, facilitando o processo de envio.'
      }
    ],
    cadastros: [
      'Cadastro de Empresa',
      'Cadastro de Parâmetros Fiscais',
      'Cadastro de CFOP'
    ],
    operacoes: [
      'Emissão de NF-e',
      'Emissão de NFS-e',
      'Emissão de NFC-e',
      'Envio de notas em lote',
      'Consulta de status na SEFAZ',
      'Cancelamento de notas',
      'Carta de Correção'
    ],
    relatorios: [
      'Relatório de Notas Emitidas',
      'Relatório de Notas Canceladas',
      'Relatório Fiscal',
      'Exportação de Sintegra'
    ],
    detalhes: {
      nfe: 'Emissão de notas fiscais eletrônicas para produtos com validação automática na SEFAZ. O sistema permite emissão individual ou em lote.',
      nfse: 'Emissão de notas fiscais de serviços eletrônicas integrada com a prefeitura. Validação automática e armazenamento seguro.',
      nfce: 'Emissão de cupons fiscais eletrônicos para vendas ao consumidor final. Integração com impressoras térmicas e validação em tempo real.',
      envioLote: 'Envio das notas do mês, todas de uma única vez, ferramenta de atualização de preços e exportação de Sintegra.'
    }
  },
  pdvDelivery: {
    id: 'pdv-delivery',
    titulo: 'PDV e Delivery',
    icone: '🛍️',
    descricao: 'Sistema completo de ponto de venda e gestão de delivery.',
    resumo: 'Vendas PDV, delivery com monitoramento de pedidos e controle de caixa.',
    funcionalidades: [
      {
        nome: 'Vendas PDV',
        descricao: 'Sistema de ponto de venda completo com emissão de cupom fiscal e controle de vendas.'
      },
      {
        nome: 'Vendas Delivery',
        descricao: 'Gestão completa de pedidos de delivery com controle de status e entrega.'
      },
      {
        nome: 'Monitoramento de Pedidos',
        descricao: 'Acompanhe em tempo real o status dos pedidos de delivery.'
      },
      {
        nome: 'Fechamento Cego PDV',
        descricao: 'Fechamento de caixa sem necessidade de contar valores manualmente.'
      },
      {
        nome: 'Sangria e Suprimento',
        descricao: 'Controle de sangria (retirada) e suprimento (adição) de valores no caixa.'
      }
    ],
    cadastros: [
      'Cadastro de Produtos',
      'Cadastro de Clientes',
      'Cadastro de Entregadores',
      'Cadastro de Formas de Pagamento'
    ],
    operacoes: [
      'Abrir / Fechar PDV',
      'Venda PDV',
      'Venda Delivery',
      'Monitoramento de Pedidos',
      'Fechamento Cego PDV',
      'Sangria',
      'Suprimento'
    ],
    relatorios: [
      'Relatório de Vendas PDV',
      'Relatório de Vendas Delivery',
      'Relatório de Fechamento de Caixa',
      'Relatório de Entregas'
    ],
    detalhes: {
      pdv: 'Sistema de ponto de venda completo com emissão de cupom fiscal, controle de vendas e integração com o módulo de estoque.',
      delivery: 'Gestão completa de pedidos de delivery com controle de status, entrega e monitoramento em tempo real.',
      monitoramento: 'Acompanhe em tempo real o status dos pedidos de delivery, desde a confirmação até a entrega.',
      fechamento: 'Fechamento de caixa sem necessidade de contar valores manualmente. Sistema calcula automaticamente os valores esperados.'
    }
  },
  servicos: {
    id: 'servicos',
    titulo: 'Módulo de Serviços',
    icone: '🔧',
    descricao: 'Controle completo do departamento de Serviços da sua empresa.',
    resumo: 'Gestão de ordens de serviço, contratos e envio de equipamentos para fábrica.',
    funcionalidades: [
      {
        nome: 'Ordem de Serviço',
        descricao: 'Controle completo de ordens de serviço com acompanhamento de status e histórico.'
      },
      {
        nome: 'Contratos',
        descricao: 'Gestão de contratos de serviços com controle de vigência e renovação.'
      },
      {
        nome: 'Envio para Fábrica',
        descricao: 'Controle de envio de equipamentos para fábrica com rastreamento.'
      },
      {
        nome: 'Faturamento de Serviços',
        descricao: 'Faturamento de serviços com emissão de NFS-e automática.'
      },
      {
        nome: 'Orçamento de Serviço',
        descricao: 'Criação de orçamentos de serviços com transformação em ordem de serviço.'
      }
    ],
    cadastros: [
      'Cadastro de Equipamentos',
      'Cadastro de Contratos',
      'Cadastro de Produtos',
      'Cadastro de Serviços',
      'Cadastro de Clientes'
    ],
    operacoes: [
      'Ordem de Serviço',
      'Contratos',
      'Envio de Equipamentos para Fábrica',
      'Faturamento',
      'Orçamento de Serviço',
      'Pesquisar Contratos'
    ],
    relatorios: [
      'Relatório de Ordens de Serviço',
      'Relatório de Contratos',
      'Relatório de Serviços Faturados'
    ],
    detalhes: {
      ordemServico: 'Controle completo de ordens de serviço com acompanhamento de status, histórico e integração com o módulo comercial.',
      contratos: 'Gestão de contratos de serviços com controle de vigência, renovação e faturamento recorrente.',
      envioFabrica: 'Controle de envio de equipamentos para fábrica com rastreamento e histórico de movimentações.',
      faturamento: 'Faturamento de serviços com emissão de NFS-e automática e integração com o módulo financeiro.'
    }
  }
};

// Recursos principais destacados
export const recursosPrincipais = [
  {
    nome: 'Geração de Boletos',
    descricao: 'Geração de boletos de quase todos os bancos nacionais com qualquer tipo de carteira.'
  },
  {
    nome: 'Controle de Caixa',
    descricao: 'Controle completo de movimentações de caixa com fechamento e relatórios.'
  },
  {
    nome: 'Contas a Pagar e Receber',
    descricao: 'Gestão completa de contas a pagar e receber com controle de vencimentos e fluxo de caixa.'
  },
  {
    nome: 'Histórico de Cheques',
    descricao: 'Controle completo do histórico de cheques emitidos e recebidos.'
  },
  {
    nome: 'Estoque',
    descricao: 'Controle completo de estoque com movimentações, estoque mínimo e curva ABC.'
  },
  {
    nome: 'Notas Fiscais',
    descricao: 'Envio de notas tipo NF-e, NFS-e e NFC-e com integração à Receita Federal.'
  }
];

// Lista de todos os módulos para navegação
export const listaModulos = Object.values(modulos);
